export default __webpack_public_path__ + "static/media/scene_03.637a5ae0.mp3";